export enum KYCStatus {
  progress,
  error,
  success,
  notStarted,
}
